
import axios from 'axios'
import Swal from 'sweetalert2';
import { apiKey, server } from '../../Config/server';

export function login(input, navigate) {
    return (dispatch, getState) => {
        // Swal.showLoading()
        // axios({
        //     method: 'POST',
        //     url: `${server}auth/login`,
        //     data: { username: input.username, password: input.password }
        // })
        //     .then((data) => {
        //         sessionStorage.setItem('token', data.data.token)
        //         sessionStorage.setItem('nama', data.data.profile.name)
        //         sessionStorage.setItem('role', data.data.profile.role)
        //         dispatch({
        //             type: "GETPROFIL",
        //             payload: data.data.data
        //         })
        //         Swal.close()
                navigate(`/loged/anggota`)
        //     })
        //     .catch(function (error) {
        //         Swal.close()
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Username atau Password Salah',
        //             text: 'Silahkan masukkan username dan password anda dengan benar!',
        //         })
        //     });
    }
}


export function setProfil() {
    return (dispatch, getState) => {
        dispatch({
            type: "GETPROFIL",
            payload: {nama: sessionStorage.namauser, role: sessionStorage.role}
        })
    }
}


export function dLogout(navigate) {
    return (dispatch, getState) => {
        Swal.showLoading()
        sessionStorage.clear()
        dispatch({
            type: "GETPROFIL",
            payload: null
        })
        Swal.close()
        navigate(`/`)
    }
}

export function getAnggota() {
    return (dispatch, getState) => {
        Swal.showLoading()
        axios({
            url: `${server}anggota`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.token}`,
            }
        })
            .then(({ data }) => {
                dispatch({
                    type: "GETANGGOTA",
                    payload: data
                })
                Swal.close()
            })
            .catch(err => {
                console.log(err);
            })
    }
}


export function getIntruksi() {
    return (dispatch, getState) => {
        Swal.showLoading()
        axios({
            url: `${server}intruksi`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.token}`,
            }
        })
            .then(({ data }) => {
                dispatch({
                    type: "GETINTRUKSI",
                    payload: data.data
                })
                Swal.close()
            })
            .catch(err => {
                console.log(err);
            })
    }
}


export function getKegiatan() {
    return (dispatch, getState) => {
        Swal.showLoading()
        axios({
            url: `${server}kegiatan`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.token}`,
            }
        })
            .then(({ data }) => {
                dispatch({
                    type: "GETKEGIATAN",
                    payload: data.data
                })
                Swal.close()
            })
            .catch(err => {
                console.log(err);
            })
    }
}



export function addSekolah(input, navigate) {
    return (dispatch, getState) => {
        Swal.showLoading()
        axios({
            url: `${server}sekolah/create`,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.token}`,
                'x-api-key': apiKey
            },
            data: input
        })
            .then(({ data }) => {
                dispatch({
                    type: "ADDSEKOLAH",
                    payload: data.data
                })
                Swal.close()
                navigate(-1)
            })
            .catch(err => {
                console.log(err);
            })
    }
}

export function deleteSekolah(id, navigate) {
    return (dispatch, getState) => {
        Swal.showLoading()
        axios({
            url: `${server}sekolah/delete/${id}`,
            method: 'delete',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.token}`,
                'x-api-key': apiKey
            }
        })
            .then(({ data }) => {
                dispatch({
                    type: "DELETESEKOLAH",
                    payload: id
                })
                Swal.close()
                Swal.fire(
                    'Sukses!',
                    'Data Berhasil Dihapus',
                    'success'
                )
                navigate(-1)
            })
            .catch(err => {
                console.log(err);
            })
    }
}
